import { render, staticRenderFns } from "./CreateMessage.vue?vue&type=template&id=b3b8d116&scoped=true"
import script from "./CreateMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateMessage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateMessage.vue?vue&type=style&index=0&id=b3b8d116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b8d116",
  null
  
)

export default component.exports